class IngredientsNH extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.desktopOff = Boolean(this.dataset.desktopOff);

      this.sliderEl = this.querySelector('.main-slider')
      this.paginationEl = this.querySelector('.swiper-pagination')

      var mainSlider = new Swiper(this.sliderEl, {
        spaceBetween: 10,
        slidesPerView: 1,
        pagination: {
          el: this.paginationEl,
          clickable: true, // Makes the pagination bullets clickable
        },
      });
    }
  
    disconnectedCallback() {}
  }
  
  customElements.define("ingredients-slider", IngredientsNH);
  